<template>
  <div class="card">
    <div class="card-block">
      <dl class="row">
        <dt class="col-sm-4">Informations admin</dt>
        <dd class="col-sm-8">
          <el-input
            v-model="value"
            type="textarea"
            autosize
            @change="() => (isEditing = true)"
            v-if="checkPermission"
          />
          <span v-else>{{ value }}</span>
        </dd>
        <dt class="col-sm-12">
          <button
            class="btn btn-sm btn-primary float-right"
            :disabled="!isEditing"
            @click="editClient"
          >
            Enregistrer la note
          </button>
        </dt>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      value: "",
      isEditing: false,
      defaultManagerNotesB2B: `Informations sur le prospect

- Nom et prénom du contact :
- Poste et responsabilités :
- Entreprise :
- Secteur d'activité :
- Effectif entreprise :
- Chiffre d'affaires :
- Localisation :
- Historique relationnel (emails, appels, rencontres) :

Contexte & enjeux

- Problématiques identifiées :
- Objectifs du prospect :
- Défis actuels :
- Solutions déjà utilisées :
- Actualités récentes de l'entreprise (croissance, levée de fonds, changements) :

Suivi post-rendez-vous

- Devis envoyé le :
- Prochain rendez-vous le :
- Action à faire avant le prochain rendez-vous :`,
    };
  },

  created() {
    this.value =
      this.client.managerNotes ||
      (this.client.isB2B ? this.defaultManagerNotesB2B : "");
  },

  computed: {
    checkPermission() {
      return (
        this.hasPermission(this.$store.state.user, "CLIENTS_WRITE") &&
        !this.client.deletedAt
      );
    },
  },

  methods: {
    editClient() {
      this.isEditing = false;

      this.$emit("edit", { name: "managerNotes", value: this.value });
    },
  },
};
</script>
